import Abstract from './abstract';
import Body from '../body';

export default () => {
  const steps = [
    {
      selector: '[data-guide="course-main@course-series:create"]',
      content: <Body title="点击新建一个课程系列" description="新建后成功后展示在下方" />,
    },
    {
      selector: '[data-guide="course-main@course:create"]',
      content: (
        <Body title="点击新建一个课程" description="新建的课程会自动归类在左侧选中的课程系列中" />
      ),
    },
  ];

  return <Abstract steps={steps} scene="main" />;
};
